import { useState, useRef } from 'react';
import lineheight from './image/lineheight.svg';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import * as EditorTypeAll from '../tinymce.d';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}
const defaultLineHeights = [
  { name: '1.0', value: 1 },
  { name: '1.5', value: 1.5 },
  { name: '1.75', value: 1.75 },
  { name: '2.0', value: 2.0 },
  { name: '3.0', value: 3.0 },
];

const Lineheight = ({ editorInstance }: Props) => {
  const btnRef = useRef(null);
  const [open, setOpen] = useState(false);

  const selectItemCl = (item: { name: string; value: number }) => {
    if (!editorInstance) return;
    editorInstance.execCommand('LineHeight', false, item.value);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div ref={btnRef} className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]">
          <img width="18px" height="18px" src={lineheight} />
        </div>
      </PopoverTrigger>
      <PopoverContent 
        className="w-auto p-0 bg-white border border-gray-300 rounded-sm shadow-lg animate-in fade-in-0 zoom-in-95 duration-200"
        align="start"
        sideOffset={5}
        style={{ zIndex: 100 }}
      >
        <div className="text-xs">
          <div className="p-0">
            {defaultLineHeights.map((item, index) => (
              <div
                key={index}
                className="flex items-center h-7 w-7 rounded justify-center cursor-pointer hover:bg-[#E5E5E5]"
                onClick={() => {
                  selectItemCl(item);
                }}
              >
                {item.value}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Lineheight;
